import { createContext, useContext } from 'react';
import type { CatalogueTemplate } from './types';

export const CatalogueTemplateContext = createContext<CatalogueTemplate | null>(null);

export const useCatalogueTemplate = () => {
  const ctx = useContext(CatalogueTemplateContext);
  if (!ctx) {
    throw new Error('CatalogueTemplateContext no está disponible');
  }
  return ctx;
};
